import React, { Component } from "react";
import { connect } from "react-redux";
import { Alert, Button, ControlLabel, Form, FormControl, FormGroup, Row } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import axios from "axios";
import getServerURL from "../../../../functions/getServerURL";

const defaultState = {
  selectedProjectLead: [],
  completedTrainingMaterials: "",
  message: null,
  submitting: false,
  fetchingRecentRequest: false,
  validationState: {
    selectedProjectLead: null,
    completedTrainingMaterials: null,
  },
  formBlocked: false,
  existingRequest: null,
  alert: null
}

class AccessRequestForm extends Component {
  state = { ...defaultState }

  componentDidMount() {
    this.getRecentRequest()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedDataSource.name !== this.props.selectedDataSource.name) {
      this.resetForm()
      this.getRecentRequest()
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({ message: null, validationState: { ...defaultState.validationState } })

    const { selectedDataSource, selectedClient, user } = this.props
    const { existingRequest, selectedProjectLead, completedTrainingMaterials } = this.state

    if (!selectedProjectLead.length || !completedTrainingMaterials || completedTrainingMaterials === "0") {
      this.setState({
        message: { text: "Please fill out all required fields", bsStyle: "danger" },
        validationState: {
          selectedProjectLead: !!selectedProjectLead.length ? "success" : "error",
          completedTrainingMaterials: (!!completedTrainingMaterials && completedTrainingMaterials !== "0") ? "success" : "error",
        }
      })
      return null
    }

    const accessRequest = {
      user: user.url,
      client: selectedClient.url,
      data_source: selectedDataSource.url,
      previous_request: existingRequest ? existingRequest.url : null,
      project_lead: selectedProjectLead[0].url,
      completed_training_materials: completedTrainingMaterials,
    }

    this.setState({ submitting: true }, () => {
      axios.post(`${getServerURL()}access-requests/`, accessRequest, {
        headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        this.setState({
          formBlocked: true,
          alert: { text: "Request has been successfully submitted.", bsStyle: "success" },
        })
      }).catch(error => {
        console.log(error, error.response)
        this.setState({
          message: { text: "There was an issue with submitting the request.", bsStyle: "danger" },
        })
      }).finally(() => {
        this.setState({ submitting: false })
      })
    })
  }

  resetForm = () => this.setState({ ...defaultState, alert: this.state.alert, existingRequest: this.state.existingRequest })

  _renderMenuItemChildren = (user, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON PROJECT LEAD/ANALYST TYPEAHEADS
    return [
      <div key="name" search={props.text}>
        <strong>{user.first_name} {user.last_name}</strong>
      </div>,
      <div key="population">
        <small>
          Email: {user.email ? user.email : "N/A"}
        </small>
      </div>,
    ]
  }

  generateAlert = (alert) => {
    const { message, status } = alert
    switch (status) {
      case "active":
        return { text: message, bsStyle: "success" }
      case "warning":
        return { text: message, bsStyle: "warning" }
      case "expired":
        return { text: message, bsStyle: "danger" }
      default:
        return null
    }
  }

  getRecentRequest = () => {
    const { selectedClient, selectedDataSource, user } = this.props

    this.setState({ fetchingRecentRequest: true }, () => {
      axios.get(`${getServerURL()}access-requests/get_recent_request/`, {
        headers: { "Authorization": `Bearer ${ localStorage.getItem("token") }` },
        params: {
          user: user.pk,
          data_source: selectedDataSource.id,
          client: selectedClient.id
        }
      }).then( response => {
        this.setState({
          alert: this.generateAlert(response.data),
          existingRequest: response.data.request || null
        })
      }).catch( error => {
        console.log(error.response, error.response.data)
        if (error.response && error.response.data) {
          this.setState({
            formBlocked: true,
            alert: { bsStyle: "danger", text: error.response.data.message }
          })
        }
      }).finally( () => {
        this.setState({ fetchingRecentRequest: false })
      })
    })
  }

  renderForm = () => {
    const { selectedClient, selectedDataSource, user, users } = this.props

    const {
      formBlocked,
      selectedProjectLead,
      message,
      alert,
      submitting,
      completedTrainingMaterials,
      validationState,
    } = this.state

    if (formBlocked) {
      return (
        <Alert bsStyle={ alert.bsStyle }>
          <center>{ alert.text }</center>
        </Alert>
      )
    }
    return (
      <Form onSubmit={ this.handleSubmit }>
        { alert &&
          <Row className="form-input-container" style={{ marginTop: "30px" }}>
            <Alert bsStyle={ alert.bsStyle } onDismiss={ () => this.setState({ alert: null }) }>
              <center>{ alert.text }</center>
            </Alert>
          </Row>
        }
        <Row className="form-input-container">
          <ControlLabel>Name <span className="required">*</span></ControlLabel>
          <FormControl disabled value={ `${user.first_name} ${user.last_name}` }/>
        </Row>
        <Row className="form-input-container">
          <ControlLabel>Email <span className="required">*</span></ControlLabel>
          <FormControl disabled value={ user.email } />
        </Row>
        <Row className="form-input-container">
          <p style={{ marginBottom: '0' }}>
            { selectedClient.name } { selectedDataSource.name } Data<br />
            { selectedDataSource.data_date_range }
          </p>
        </Row>
        <Row className="form-input-container">
          <strong>Duration of Access:</strong> { selectedDataSource.max_request_time } days
        </Row>
        <Row className="form-input-container">
          <FormGroup validationState={ validationState.selectedProjectLead }>
            <ControlLabel>Project Lead <span className="required">*</span></ControlLabel>
            <Typeahead
              id="ProjectLeadsFilterTypeahead"
              disabled={ submitting }
              clearButton
              labelKey={ user => `${user.first_name} ${user.last_name}` }
              renderMenuItemChildren={this._renderMenuItemChildren}
              selected={ selectedProjectLead }
              options={ users.filter(userOption => userOption.department !== "Former Employee" && userOption.email.includes("genesisrg.com")) }
              placeholder="Project Lead"
              onChange={ selectedProjectLead => this.setState({ selectedProjectLead }) }
            />
          </FormGroup>
        </Row>
        { Boolean(selectedDataSource.training_materials.length) &&
          <Row className="form-input-container">
            <div>
              Please go through the associated training materials
              <ol>
                { selectedDataSource.training_materials.map(material => (
                  <li key={ material.url }>
                    <a href={ material.material_url } target="_blank" rel="noreferrer">{ material.name }</a>
                  </li>
                )) }
              </ol>
            </div>

          </Row>
        }
        <Row className="form-input-container">
          <FormGroup validationState={ validationState.completedTrainingMaterials }>
            <ControlLabel>Completed Training Materials <span className="required">*</span></ControlLabel>
            <FormControl
              componentClass="select"
              disabled={ submitting }
              placeholder="Choose"
              value={ completedTrainingMaterials }
              onChange={ (e) => this.setState({ completedTrainingMaterials: e.target.value }) }
            >
              <option value="">Choose</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </FormControl>
          </FormGroup>
        </Row>
        { Boolean(message) &&
          <Row className="form-input-container">
            <Alert
              bsStyle={ message.bsStyle }
              onDismiss={ () => this.setState({ message: null }) }
            >
              { message.text }
            </Alert>
          </Row>
        }
        <Row className="form-input-container">
          <FormGroup>
            <div style={{ float: 'right' }}>
              <Button bsStyle="success" type="submit" disabled={ submitting }>Submit</Button>
              <Button bsStyle="link" onClick={ this.resetForm } disabled={ submitting }>Reset Form</Button>
            </div>
          </FormGroup>
        </Row>
      </Form>
    )
  }

  render() {
    const { selectedClient, selectedDataSource } = this.props
    const { fetchingRecentRequest } = this.state

    return (
      <div className="request-access-form">
        <center>
          <h4>
            { selectedClient.name } { selectedDataSource.name } Data Access Request Form
          </h4>
        </center>
        { fetchingRecentRequest ?
          <center>
            <div id="not-found">
              <img alt="loader" src={require("../../../../static/images/spinner.gif")} />
            </div>
          </center>
          :
          this.renderForm()
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.manageLogin.user,
    users: state.manageLogin.users,
  }
}

export default connect(mapStateToProps)(AccessRequestForm)


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequest/components/AccessRequestForm.js